import React from 'react'
import PropTypes from 'prop-types'
import convertHexToRgba from 'lib/hex-to-rgba'
import { Box, Stack, Flex, Image } from '@chakra-ui/react'
import { loadImage } from 'integrations/unsplash'
import dynamic from 'next/dynamic'

const BannerTitle = dynamic(() => import(/* webpackChunkName: 'BannerTitle' */ '../../../../../../components/hub-page/views/sections/banner/components/title'))
const BannerDescription = dynamic(() => import(/* webpackChunkName: 'BannerDescription' */ '../../../../../../components/hub-page/views/sections/banner/components/description'))
const BannerCTA = dynamic(() => import(/* webpackChunkName: 'BannerCTA' */ '../../../../../../components/hub-page/views/sections/banner/components/cta'))

const BannerLayoutOne = ({ data, theme, meta, dataTestId, brandColor }) => {
  const minHeight = theme.minHeight
  const showImageTag = data.fullHeight

  if (showImageTag) {
    return (
      <Image
        w='full'
        src={loadImage(data.image, meta.imageSize || 1000, 2500)}
        alt={!data.altText ? '' : data.altText}
        data-testid={dataTestId}
      />
    )
  }

  return (
    <Flex
      alignItems='center'
      bg={theme.backgroundColor}
      backgroundImage={`url(${loadImage(
        data.image,
        meta.imageSize || 1000,
        2500
      )})`}
      backgroundPosition={`${data.imgFocalX}% ${data.imgFocalY}%`}
      backgroundRepeat='no-repeat'
      backgroundSize='cover'
      justifyContent='center'
      minHeight={minHeight}
      p={[4, 4, 16, 16]}
      aria-label={!data.altText ? '' : data.altText}
      data-tetid={dataTestId}
    >
      <Box
        boxShadow='site'
        rounded='site'
        bg={`${convertHexToRgba(theme.backgroundColor, theme.bannerOpacity)}`}
        maxWidth='2xl'
        p={[4, 4, 8, 8]}
        textAlign='center'
        w='full'
      >
        <Stack spacing={4}>
          <Box>
            <BannerTitle theme={theme} data={data} />
          </Box>
          <Box>
            <BannerDescription theme={theme} data={data} brandColor={brandColor}/>
          </Box>
          <Box>
            <BannerCTA theme={theme} data={data} />
          </Box>
        </Stack>
      </Box>
    </Flex>
  )
}

BannerLayoutOne.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  meta: PropTypes.object,
  dataTestId: PropTypes.string.isRequired,
  brandColor: PropTypes.string.isRequired
}

export default BannerLayoutOne
